/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
export * from './apis/admin-api';
export * from './apis/alarm-api';
export * from './apis/auth-api';
export * from './apis/auth-public-api';
export * from './apis/dashboards-api';
export * from './apis/devices-api';
export * from './apis/health-api';
export * from './apis/incidence-api';
export * from './apis/ingestion-api';
export * from './apis/maintenance-orders-api';
export * from './apis/my-account-api';
export * from './apis/otafirmware-management-api';
export * from './apis/patients-api';
export * from './apis/sessions-api';
export * from './apis/survey-api';
export * from './apis/user-not-authenticated-api';
export * from './apis/users-api';
export * from './apis/videos-api';
